export default __webpack_public_path__ + "images/leaflet/marker-icon-2x.png";